import { ButtonMui } from 'src/components/ButtonMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

const flexCenter = `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

export const Info = styled.div`
  ${flexCenter}
  padding: 0 1.4rem 1.4rem 1.4rem;
  gap: 1rem;
`
export const ContainerProductName = styled.div`
  ${flexCenter}
`

export const Form = styled.form`
  ${flexCenter}
  padding: 1.4rem 0;
  flex-grow: 1;
  width: 100%;
  justify-content: flex-end;
`

export const ContainerButton = styled.div`
  display: flex;
  gap: 1.4rem;
  padding: 0 1.4rem 0 1.4rem;
  width: 100%;
`

export const CustomButton = styled(ButtonMui)`
  width: 100%;    
  height: 2.8rem !important;
  margin: 0 !important;
`
export const ContainerDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: .5rem;

  p {
    font-size: 16px;
  }
`

export const ContainerRestockCards = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 44vh;
  gap: .4rem;
  overflow-y: auto;
`

export const CustomTextField = styled(TextFieldMui)`
  margin: 0 !important;
  height: 2.5rem !important;
  width: 100%;
  margin: 0 0 .4rem 0 !important;
  border-radius: 4px;
`
